import React from 'react';
import cx from 'classnames';
import { useIsMobile } from '@bwoty-web/ui-kit/hooks';
import { DraggableDrawer } from '@bwoty-web/ui-kit';

import HotelContainer from '../HotelContainer';

import './selectedHotel.scss';

const SelectedHotel = ({ hotel, onClose, location }) => {
  const isMobile = useIsMobile();

  return (
    <DraggableDrawer defaultHeight={70} show onClose={onClose} disabled={!isMobile}>
      <div className={cx({ 'hf-hotel-map-view__wrapper': !isMobile })}>
        <HotelContainer
          hotelObject={hotel}
          location={location}
          onClose={onClose}
        />
      </div>
    </DraggableDrawer>
  );
};

export default SelectedHotel;
